function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * @description: 隐藏敏感信息
 * @author: zhangxin14
 * @since: 2018-05-30 11:29:10
 * @param str 需要处理的字符串
 * @param start 替换的起始位置
 * @param end 替换的截止位置
 * @param replaceStr 替换的字符串
 * @return 处理之后的字符串
 */
var hideSensitiveText = function hideSensitiveText(str, start, end) {
  var replaceStr = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '*';
  var subStrArr = str.split('');
  return [].concat(_toConsumableArray(subStrArr.slice(0, start - 1)), _toConsumableArray(subStrArr.slice(start - 1, end).fill(replaceStr)), _toConsumableArray(subStrArr.slice(end))).join('');
};

export default hideSensitiveText;